import { defineMessages } from 'react-intl';

export default defineMessages({
  // Columns
  email: 'Email',
  firstname: 'First name',
  lastname: 'Last name',
  phone: 'Phone number',
  authRoles: 'Roles',
  loginCount: 'Login count',
  lastLogin: 'Last login',
  lastLoginDate: 'Last login date',

  blocked: 'Blocked',
  active: 'Active',
  invited: 'Invited',

  // Actions
  blockUser: 'Block user',
  unblockUser: 'Unblock user',
  editUser: 'Edit user',
  createUser: 'Create user',
  inviteUser: 'Invite user',
  copyInvitationLink: 'Copy invitation link',
  linkCopied: 'Invitation link is copied to your clipboard',
  linkCopyFailed: 'Failed to access your clipboard, please try copying the link below.',
  inviteUserFailed: 'Failed to invite user, please try again later.',
  upsertUserFailed: 'Failed to create or update user, please try again later.',

  emailRequired: 'Email is required',
  emailInvalid: 'Please enter a valid email',

  internalRoles: 'Global roles',

  blockedDescription: 'Prevent user from logging in',

  confirmDeleteUser: 'Are you sure you want to delete {email}?',

  invitationSent: 'An invitation has been sent to {email}',
  alreadyActive: '{email} is already an active user. No invitation has been sent, but their access has been updated.',
  sendInvitation: 'Send invitation',

  impersonate: 'Impersonate',
});
